import React from 'react';

/**
 * Reusable character counter indicator displaying `current/max` with consistent styling.
 */
const EpmCharCounter = ({ current = 0, max, className = '' }) => {
    const count = typeof current === 'string' ? current.length : (Number(current) || 0);
    return (
        <span className={`text-xs text-stride-muted-light ${className}`.trim()}>
            {count}/{max}
        </span>
    );
};

export default EpmCharCounter;

